import React from 'react';
import { Share2 } from 'lucide-react';
import { toast } from 'sonner';

const ShareButton = ({ url, title, text, className = '' }) => {
  const shareUrl = url || window.location.href;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, text, url: shareUrl });
      } catch (err) {
        if (err.name !== 'AbortError') {
          fallbackCopy();
        }
      }
    } else {
      fallbackCopy();
    }
  };

  const fallbackCopy = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      toast.success('Link copied to clipboard!');
    }).catch(() => {
      toast.error('Failed to copy link');
    });
  };

  return (
    <button
      onClick={handleShare}
      className={`inline-flex items-center justify-center w-9 h-9 rounded-full bg-white/80 backdrop-blur-sm border border-gray-200 text-gray-600 hover:text-[#FF8C00] hover:border-[#FF8C00]/30 transition-colors ${className}`}
      data-testid="share-btn"
      aria-label="Share"
      title="Share"
    >
      <Share2 className="w-4 h-4" />
    </button>
  );
};

export default ShareButton;
